module.exports = __webpack_public_path__ + "img/tree-07-c-leaves.2d21dcc3.png";